import React, { useContext, useEffect, useState } from 'react';
import './pagination.scss';
import { useBbtContent } from '../../../support/components/browse-by-topic/hook/use-bbt-content';
import ServerContext from '../../../contexts/serverContext';
import { BRAND } from '../../../constants';
import Link from '../link/link';
import { PaginationAttributes } from '../../../support/models/pagination-attributes';
import { PaginationDataListItem } from '../../../support/components/pagination-data-list/pagination-data-list-item';
import { useSupportCommonContent } from '../../../support/components/astute-topic/hook/use-support-common';
import { FdsChevron } from '../chevron/fds-chevron';

interface Props {
    data: any;
    itemsPerPage: number;
    isNoScroll?: boolean;
}
export const Pagination = (props: Props) => {
    const [currentData, setCurrentData] = useState<React.JSX.Element[]>();
    const [currentPage, setCurrentPage] = useState(1);
    const maxPage = Math.ceil(props.data.length / props.itemsPerPage);

    const data = () => {
        const begin = (currentPage - 1) * props.itemsPerPage;
        const end = begin + props.itemsPerPage;
        const postData = props.data
            .slice(begin, end)
            .map((topic: PaginationAttributes) => (
                <PaginationDataListItem key={topic.id} topic={topic} />
            ));
        setCurrentData(postData);
    };
    const next = () => {
        setCurrentPage(currentPage => Math.min(currentPage + 1, maxPage));
        if (!props.isNoScroll) {
            window.scrollTo(0, 0);
        }
    };

    const prev = () => {
        setCurrentPage(currentPage => Math.max(currentPage - 1, 1));
        if (!props.isNoScroll) {
            window.scrollTo(0, 0);
        }
    };
    useEffect(() => {
        data();
    }, [currentPage]);
    const bbtContent = useBbtContent();
    const supportCommonContent = useSupportCommonContent();
    const serverContext = useContext(ServerContext);

    const currentRoot = serverContext.root
        ? serverContext.root.substring(0, serverContext.root.length - 1)
        : '';
    return (
        <>
            {currentData}
            <div className="crawler-links">
                {props.data.map(
                    (paginationAttributes: PaginationAttributes) => (
                        <p key={paginationAttributes.id}>
                            <Link
                                href={`${currentRoot}${paginationAttributes.link}`}
                            >
                                {paginationAttributes.label}
                            </Link>
                        </p>
                    )
                )}
            </div>
            <nav className="pagination" aria-label="pagination">
                <div className="fds-pagination">
                    <span
                        className={`fds-pagination__item fds-pagination__prev ${
                            currentPage === 1 ? 'fds-pagination__disabled' : ''
                        }`}
                        onClick={prev}
                    >
                        <FdsChevron
                            type="unfilled"
                            direction="left"
                        ></FdsChevron>
                        {serverContext.brand === BRAND.ford.LONG_NAME
                            ? bbtContent?.prevLabel
                            : ''}
                    </span>
                    <ul className="mobile-pagination">
                        <li className="fds-pagination__item">
                            <span className="fds-pagination__link">
                                {currentPage}
                                <span className="pagination-of">
                                    {serverContext.brand ===
                                    BRAND.ford.LONG_NAME
                                        ? supportCommonContent?.paginationOf
                                        : '/'}
                                </span>
                                {maxPage}
                            </span>
                        </li>
                    </ul>

                    <span
                        className={`fds-pagination__item fds-pagination__next ${
                            currentPage === maxPage
                                ? 'fds-pagination__disabled'
                                : ''
                        }`}
                        onClick={next}
                    >
                        {serverContext.brand === BRAND.ford.LONG_NAME
                            ? bbtContent?.nextLabel
                            : ''}
                        <FdsChevron
                            type="unfilled"
                            direction="right"
                        ></FdsChevron>
                    </span>
                </div>
            </nav>
        </>
    );
};
